import { render, staticRenderFns } from "./WarehouseDetails_Action.vue?vue&type=template&id=672a5669&"
import script from "./WarehouseDetails_Action.vue?vue&type=script&lang=js&"
export * from "./WarehouseDetails_Action.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports